import { ScopeButton } from '@monorepo/shared-lib';
import { Spin, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import routes from 'routes';
import { BaseCard } from './BaseCard';
import { VatNumberCheckerCardProps } from './CardProps';

const { Text, Paragraph } = Typography;

const statRow = (
  label: string,
  value: React.ReactNode,
  valueColor?: string
) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 12,
    }}
  >
    <Text style={{ fontSize: 14, color: '#5c6c6c' }}>{label}</Text>
    <Text
      style={{
        fontSize: 14,
        fontWeight: 600,
        color: valueColor || 'var(--color-text-dark, #042a2a)',
        textAlign: 'right',
      }}
    >
      {value}
    </Text>
  </div>
);

export const VatNumberCheckerCard: React.FC<VatNumberCheckerCardProps> = ({
  dashboardViewType,
  cardId,
  vatCheckerSummary,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (dashboardViewType !== 'my') return null;

  const {
    qualifiedEntityCount,
    activeCount,
    entitiesWithInvalidFlags,
    loading,
  } = vatCheckerSummary;

  const showStatsSpinner = loading && qualifiedEntityCount === 0;

  return (
    <BaseCard cardId={cardId}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 16,
          height: '100%',
          minHeight: 120,
        }}
      >
        <Paragraph
          style={{
            marginBottom: 0,
            fontSize: 13,
            lineHeight: 1.5,
            color: '#5c6c6c',
          }}
        >
          {t('main.vat-number-checker-card-description')}
        </Paragraph>

        {showStatsSpinner ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '12px 0',
            }}
          >
            <Spin size="small" />
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {statRow(
              t('main.vat-checker-stat-active-label'),
              t('main.vat-checker-stat-active-value', {
                active: activeCount,
                total: qualifiedEntityCount,
              })
            )}
            {statRow(
              t('main.vat-checker-stat-flags-label'),
              entitiesWithInvalidFlags > 0
                ? t('main.vat-checker-stat-flags-value', {
                    count: entitiesWithInvalidFlags,
                  })
                : t('main.vat-checker-stat-flags-none'),
              entitiesWithInvalidFlags > 0 ? '#d4380d' : 'var(--color-text-dark, #042a2a)'
            )}
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <ScopeButton
            type="primary"
            width="70%"
            height="40px"
            fontSize="14px"
            onClick={() => navigate(routes.vies.qualifiedEntities)}
          >
            <Text style={{ color: '#fff', fontWeight: 600 }}>
              {t('main.open-vat-number-checker')}
            </Text>
          </ScopeButton>
        </div>
      </div>
    </BaseCard>
  );
};
